import { useMemo } from 'react';
import { useGoal } from '../../../../hooks/useGoal';
import { useIsCurrentPlanSelected } from '../../../../hooks/useIsCurrentPlanSelected';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { RetirementAssetsChartDTO } from '../../components/RetirementChart/RetirementChart.meta';

interface UseOverviewParams {
  goalId?: string;
  isPrint?: boolean;
}

export const useOverview = ({ goalId, isPrint }: UseOverviewParams) => {
  const queryResult = useGoal({ goalId });

  const { clientId } = useRouteParams();

  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const goal = queryResult.data;

    if (!goal) {
      return null;
    }

    const { GoalCharts } = goal;

    if (!GoalCharts) {
      return null;
    }

    const chartData = GoalCharts[0] as RetirementAssetsChartDTO;

    if (!chartData) {
      return null;
    }

    return {
      chartData,
      proposedPlanName: !isPrint ? ADV.consumer.getPlanName(clientId) : 'Proposed Plan',
      currentPlanTooltip: ADV.tooltip_callouts.RetirementAssetsChart.Current.html,
      proposedPlanTooltip: ADV.tooltip_callouts.RetirementAssetsChart.ProposedPlan.html,
      isCurrentPlanSelected,
    };
  }, [queryResult.data, isCurrentPlanSelected, isPrint, clientId]);

  return {
    ...queryResult,
    data,
  };
};
